module.exports = __webpack_public_path__ + "img/exchange-coupon-icon.8cc9d5c6.png";